import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, Building2, DollarSign, MapPin, Phone } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { useAuth } from "../AuthContext";
import { useParams } from 'react-router-dom';
import { createProspect } from '../lib/inspectionService';

const ProspectForm = () => {
  const navigate = useNavigate();
  const { userId } = useAuth();
  const { propertyId } = useParams();

  const [formData, setFormData] = useState({
    name: '',
    Phone: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, phone } = formData;
    const prospect = await createProspect(userId, propertyId, name, phone);
    navigate(`/properties/${propertyId}/prospects`); // Redirect to prospects list
  };

  return (
    <div className="container mx-auto px-6 py-8">
      <Link to={`/properties/${propertyId}/Prospects`} className="text-gray-600 flex items-center gap-2 mb-6">
        <ArrowLeft className="w-4 h-4" />
        Back to Prospects
      </Link>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Building2 className="w-6 h-6" />
            Add New Prospect
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="space-y-4">
                    <h3 className="text-lg font-semibold">Basic Information</h3>
                    <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium mb-1">Name</label>
                      <div className="relative">
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full pl-10 p-2 border rounded"
                        required
                      />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">Phone</label>
                      <div className="relative">
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full pl-10 p-2 border rounded"
                        required
                      />
                      </div>
                    </div>
                    </div>
                  </div>


                  {/* Submit Button */}
            <div className="flex justify-end space-x-4">
              <button
                type="button"
                onClick={() => navigate(`/properties/${propertyId}/prospects`)}
                className="px-4 py-2 border rounded hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
              >
                Create Prospect
              </button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProspectForm;